/**
 * Admin: App Settings page.
 *
 * Tab-based shell for global application configuration. v1 has only the
 * Disclaimer tab; future global settings (branding, defaults, feature
 * toggles, etc.) live as siblings here.
 */

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui'
import { PageFrame } from '@/components/layout/PageFrame'
import { PageHeader } from '@/components/layout/PageHeader'
import { DisclaimerSettings } from '@/pages/admin/app-settings/DisclaimerSettings'
import { HelpFeedbackSettings } from '@/pages/admin/HelpFeedbackSettings'
import { PromptCaptureSettings } from '@/pages/admin/PromptCaptureSettings'

export function AppSettingsPage() {
  return (
    <PageFrame width="form" className="space-y-4">
      <PageHeader title="App Settings" subtitle="Global configuration for this deployment." />

      <Tabs defaultValue="disclaimer">
        <TabsList>
          <TabsTrigger value="disclaimer">Disclaimer</TabsTrigger>
          <TabsTrigger value="help-feedback">Help &amp; feedback</TabsTrigger>
          <TabsTrigger value="prompt-capture">Prompt capture</TabsTrigger>
        </TabsList>
        <TabsContent value="disclaimer" className="mt-4">
          <DisclaimerSettings />
        </TabsContent>
        <TabsContent value="help-feedback" className="mt-4">
          <HelpFeedbackSettings />
        </TabsContent>
        <TabsContent value="prompt-capture" className="mt-4">
          <PromptCaptureSettings />
        </TabsContent>
      </Tabs>
    </PageFrame>
  )
}
